import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    backgroundImage:
      'linear-gradient(to right, #3E3B7C 1%, #21244E 42.1%, #0B132B 90.47%)',
    width: '100%',
    height: ['auto', '104px'],
  },
  mainBackgroundImage: {
    width: '100%',
    height: '100%',
    display: ['none', 'block'],
    '&:before, &:after': {
      backgroundPosition: 'top !important',
    },
  },
  backgroundImageContainer: {
    width: '100%',
    height: '100%',
  },
  mainMobileBackgroundImage: {
    width: '100%',
    height: '100%',
    display: ['block', 'none'],
    '&:before, &:after': {
      backgroundPosition: 'top !important',
    },
  },
  mainFlexContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
  },
  flexContainer: {
    flexDirection: ['column', 'row'],
    alignItems: 'center',
    margin: ['45px auto 54px auto', 'auto'],
  },
  text: {
    color: 'white',
    margin: ['0 67px', '0 74px 0 0'],
    textAlign: ['center', 'auto'],
    paddingX: ['30px', 'auto'],
  },
  cta: {
    marginTop: ['54px', '0'],
  },
};
